/* eslint-disable react/jsx-no-bind */
import { Modal, Result } from 'antd';
import React from 'react';

export function ModalOrderCanceledWarning({ isModalOpen }) {
  return (
    <Modal
      title="Esse pedido foi cancelado"
      open={isModalOpen}
      footer={null}
      width={700}
      closable={false}
    >
      <Result status="warning" title="O pedido foi cancelado" />
    </Modal>
  );
}
